import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-navy py-10 sm:py-14" data-id="element-198" data-mp="3mf7pges1bkaz">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-199" data-mp="3r78xtpm30qvq">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-white sm:text-sm" data-id="element-200" data-mp="3r9locr5wo9ke">
          <span aria-hidden="true" data-id="element-201" data-mp="41887lnmv8qn">⭐</span>
          Testimonios reales
        </span>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-202" data-mp="937cqyv40bp6">
          Profesores de toda España ya lo usan.
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-203" data-mp="2atsmge7e6nvh">
          <StarRating size={18} data-id="element-204" data-mp="2fsc627yijnko" />
          <span className="text-sm text-white/70" data-id="element-205" data-mp="2frkc11kkdxwi">+500 reseñas verificadas</span>
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-206" data-mp="1slkq3bo9z6hg">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-white/10 bg-white/5 p-6" data-id="element-207" data-mp="1nrpyzn6cbp8c" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-208" data-mp="26jsl3e1r3xpz">
              <StarRating size={14} data-id="element-209" data-mp="26ihfd8oqwfw8" />
              <span aria-hidden="true" data-id="element-210" data-mp="22hxje8fwribo">🇪🇸</span>
            </div>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-white/90" data-id="element-211" data-mp="22kjn1wzohdom">"{t.text}"</p>
            <div className="mt-4 border-t border-white/10 pt-3" data-id="element-212" data-mp="1xlyos33zl42t">
              <p className="text-sm font-semibold text-white" data-id="element-213" data-mp="r4bjbs8ifwbd">{t.name}</p>
              <p className="text-xs text-white/60" data-id="element-214" data-mp="m47cyv1bghyv">{t.role}</p>
            </div>
          </m.div>)}
      </div>

      <p className="mt-6 text-center text-sm text-white/70 sm:text-base" data-id="element-215" data-mp="nmxmy0rarzfx">
        Más de <span className="font-bold text-yellow" data-id="element-216" data-mp="skz6emsmy0rx">8.000 profesores</span> de EF en España ya enseñan
        con EDUCACIÓN FÍSICA FLASH.
      </p>
    </section>;
}